import { Box, Image, Typography } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import {
  Space,
  useImpressionTracking,
} from "@outschool/ui-legacy-component-library";
import { useNodeRef } from "@outschool/ui-utils";
import React from "react";

import blobBannerBg from "../../../../images/banners/welcome/blob_banner_bg.png";
import Link from "../../components/Link";
import { DESKTOP_BANNER_HEIGHT, MOBILE_BANNER_HEIGHT } from "./consts";

export interface CommunityBannerProps {
  bannerData: {
    title: string;
    subtitle: string;
    ctaText: string;
    ctaUrl: string;
    image: {
      title: string;
      url: string;
    };
  };
}

const CommunityBanner = ({ bannerData }: CommunityBannerProps) => {
  const trackingPrefix = "banner.community";
  const [impressionNode, setImpressionNode] = useNodeRef();
  useImpressionTracking({
    node: impressionNode,
    uniqueId: trackingPrefix,
    trackingLabel: trackingPrefix,
    trackViews: true,
  });

  const { title, subtitle, ctaText, ctaUrl, image } = bannerData;

  return (
    <Box
      sx={(theme: $TSFixMe) => ({
        backgroundImage: `url("${blobBannerBg}")`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        height: MOBILE_BANNER_HEIGHT,
        [theme.breakpoints.up("sm")]: {
          height: DESKTOP_BANNER_HEIGHT,
        },
      })}
      data-test-id="community-banner"
      ref={setImpressionNode}
    >
      <Box
        flex
        sx={(theme: $TSFixMe) => ({
          alignItems: "center",
          justifyContent: "center",
          paddingX: "12px",

          [theme.breakpoints.up("sm")]: {
            paddingX: "1em",
          },

          marginTop: "80px",
        })}
      >
        <Box
          flex
          sx={(theme: $TSFixMe) => ({
            flexDirection: "column",
            alignItems: "normal",

            [theme.breakpoints.up("sm")]: {
              alignItems: "center",
              textAlign: "center",
              maxWidth: "400px",
            },

            textAlign: "left",
            maxWidth: "300px",
          })}
        >
          <Typography
            variant="h2"
            component="div"
            sx={(theme: $TSFixMe) => ({
              fontSize: "1em",

              [theme.breakpoints.up("sm")]: {
                fontSize: "1.5em",
              },

              fontWeight: 900,
            })}
          >
            {title}
          </Typography>
          <Space y={8} />
          <Typography
            variant="inherit"
            sx={(theme: $TSFixMe) => ({
              fontSize: "0.875em",

              [theme.breakpoints.up("sm")]: {
                fontSize: "1em",
              },
            })}
          >
            {subtitle}
          </Typography>
          <Space y={4} />
          <Link
            style={{ zIndex: 1, fontWeight: 500 }}
            to={ctaUrl}
            target="_blank"
            trackingName={trackingPrefix + "_touch"}
          >
            {ctaText}
          </Link>
        </Box>
        <Space x="medium" />
        <Image
          sx={{
            maxWidth: 125,
          }}
          src={image?.url || undefined}
          alt={image?.title || undefined}
        />
      </Box>
    </Box>
  );
};

export default CommunityBanner;
